class QualucaBlogIndex extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    this.buttons = [...this.querySelectorAll('[data-qualuca-filter]')];
    this.cards = [...this.querySelectorAll('[data-qualuca-article]')];
    this.search = this.querySelector('[data-qualuca-search]');
    this.status = this.querySelector('[data-qualuca-results]');
    this.empty = this.querySelector('[data-qualuca-empty]');
    this.activeCategory = 'all';

    this.buttons.forEach((button) => {
      button.addEventListener('click', () => {
        this.activeCategory = button.dataset.qualucaFilter || 'all';
        this.buttons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        this.applyFilters();
      });
    });

    this.search?.addEventListener('input', () => this.applyFilters());
    this.applyFilters();
  }

  normalize(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
  }

  applyFilters() {
    const query = this.normalize(this.search?.value);
    let visibleCount = 0;

    this.cards.forEach((card) => {
      const categories = (card.dataset.categories || '').split(/\s+/);
      const categoryMatches = this.activeCategory === 'all' || categories.includes(this.activeCategory);
      const searchMatches = !query || this.normalize(card.dataset.search).includes(query);
      const isVisible = categoryMatches && searchMatches;
      card.hidden = !isVisible;
      if (isVisible) visibleCount += 1;
    });

    if (this.status) {
      this.status.textContent = visibleCount === 1 ? '1 articol găsit' : `${visibleCount} articole găsite`;
    }
    if (this.empty) this.empty.hidden = visibleCount !== 0;
  }
}

if (!customElements.get('qualuca-blog-index')) {
  customElements.define('qualuca-blog-index', QualucaBlogIndex);
}
